"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LHA_RESIDUAL_NOTE_MIN_LENGTH = exports.lhaOverrideSubjectTypeSchema = exports.LHA_OVERRIDE_SUBJECT_TYPES = exports.lhaPeriodReasonCodeSchema = exports.LHA_PERIOD_REASON_CODES = void 0;
const zod_1 = require("zod");
// LHA submission accept-with-reason. A period-alignment acceptance picks one
// of these closed reasons; a residual exception carries a written explanation instead.
exports.LHA_PERIOD_REASON_CODES = [
    'qp_window_unresolved',
    'position_rolls_before_qp_opens',
    'counterparty_priced_early',
    'immaterial_timing_difference',
];
exports.lhaPeriodReasonCodeSchema = zod_1.z.enum(exports.LHA_PERIOD_REASON_CODES);
// The two override points the reason store serves at launch (per-BL eligibility override is wired later).
exports.LHA_OVERRIDE_SUBJECT_TYPES = ['period_alignment', 'residual_exception'];
exports.lhaOverrideSubjectTypeSchema = zod_1.z.enum(exports.LHA_OVERRIDE_SUBJECT_TYPES);
// A residual exception's written explanation must be substantive — a single word
// is not an audit trail. Enforced on the client and the server from this one value.
exports.LHA_RESIDUAL_NOTE_MIN_LENGTH = 10;
//# sourceMappingURL=lha-override-reason.js.map